
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { LandingFormData } from "../hooks/useLandingForm";
import { countries } from "../countryData";

interface CountrySectionProps {
  formData: LandingFormData;
  handleCountryChange: (value: string) => void;
}

const CountrySection = ({ formData, handleCountryChange }: CountrySectionProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="country">Country *</Label>
      <Select
        value={formData.country}
        onValueChange={handleCountryChange}
        required
      >
        <SelectTrigger id="country">
          <SelectValue placeholder="Select your country" />
        </SelectTrigger>
        <SelectContent>
          {countries.map((country) => (
            <SelectItem key={country} value={country}>
              {country}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default CountrySection;
